<div class="mfa">
  <div class="col-10 mx-auto">
    <p class="text-center">
      Logging in as
      <b
        ><i>{{ username }}</i></b
      >
    </p>
    <label for="mfa" class="visually-hidden">
      Two-factor authentication token
    </label>
    <!-- <input
      id="mfa"
      type="text"
      placeholder="2FA password"
      class="input-text"
      (keyup.enter)="login()"
      [(ngModel)]="mfaToken"
      autocomplete="off"
    /> -->
    <ng-otp-input
      (keyup.enter)="login()"
      [(ngModel)]="mfaToken"
      [config]="{
        length: 6,
        allowNumbersOnly: true,
        inputClass: 'input-text border-input',
        containerClass: 'otp-container',
      }"
    ></ng-otp-input>

    <div
      class="options d-flex flex-column justify-content-center gap-2 align-items-center mt-3"
    >
      <button
        class="button btn-login primary"
        (click)="login()"
        [disabled]="loading()"
      >
        Login
      </button>
      <button
        class="button btn-passkey"
        [disabled]="loading()"
        (click)="loginPasskey()"
      >
        <span class="passkey-icon-svg"></span>
        Passkey
      </button>
    </div>
  </div>
  <mat-progress-bar
    [class.visually-hidden]="!loading()"
    class="top-loading-bar"
    mode="indeterminate"
  ></mat-progress-bar>
</div>
